import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-patient-reply",
    templateUrl: "./patient-reply.component.html",
    styleUrls: ["./patient-reply.component.scss"],
})
export class PatientReplyComponent implements OnInit {
    fileToUpload: File;
    message: string = "";
    constructor(
        public dialogRef: MatDialogRef<PatientReplyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {}

    confirm() {
        this.dialogRef.close({
            file: this.fileToUpload,
            message: this.message,
            action: true,
        });
    }

    onChangeFile(event) {
        this.fileToUpload = event.target.files[0];
    }

    cancel() {
        this.dialogRef.close({ action: false });
    }
}
